import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActionBarOptions } from '@shared/components/atoms/actions/action-bar-options.model';
import { ActionBarAction } from '@features/documents/document-tab/document-tab.component';

@Component({
  selector: 'xt-portal-action-bar',
  templateUrl: './action-bar.component.html',
  styleUrls: ['./action-bar.component.scss'],
    standalone: false
})
export class ActionBarComponent {
  @Input() data: any[] = [];
  @Input() selectedData: any[] = [];
  @Input() showChecked: boolean;
  @Input() actionBarActions: ActionBarAction[];
  @Input() dataCy: string;

  @Output() selectAllHandler = new EventEmitter();
  @Output() deSelectAllHandler = new EventEmitter();
  @Output() actionHandler = new EventEmitter();

  protected actions: ActionBarOptions = {
    edit: false,
    share: false,
    download: false,
    delete: false,
  };

  filterFunction(d): boolean {
    return d.isSelected;
  }

  /**
   * check if there are already elements selected
   *
   * @return boolean or 'all'
   */
  checkboxFilter(): boolean | 'all' {
    const selectedDataCount = this.selectedData?.length || 0;
    const dataCount = this.data?.length || 0;
    if (selectedDataCount > 0 && selectedDataCount < dataCount) {
      // if some are selected and not all
      return true;
    } else if (selectedDataCount === dataCount) {
      // if all are selected
      return 'all';
    } else {
      // if none are selected
      return false;
    }
  }

  getSelectedDocuments(): any[] {
    return this.selectedData;
  }

  /**
   * selects/deselects all elements
   *
   * @param e click event
   */
  selectAll(e) {
    if (e.checked) {
      this.selectAllHandler.emit();
    } else {
      this.deselectAll();
    }
  }

  /**
   * deselects all elements
   *
   */
  deselectAll() {
    this.deSelectAllHandler.emit();
  }

  action(methodName) {
    this.actionHandler.emit({
      methodName,
      rows: this.getSelectedDocuments(),
    });
  }
}
